module.exports = __webpack_public_path__ + "img/platform-icon-4.cbca1b6b.png";